<template>
	<vx-card :title="$t('CompanyModule.AdminResource')" no-shadow card-border>
		<div class="vx-row">
			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					name="username"
					v-model="resource.username"
					v-validate="'required|alpha_num'"
					:label="$t('Username')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first("username") }}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					name="name"
					v-model="resource.name"
					v-validate="'required|alpha_spaces'"
					:label="$t('Name')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('ResourceModule.Table.Lastname')"
					v-model="resource.lastname"
					v-validate="'required|alpha_spaces'"
					name="lastname"
				/>
				<span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first("lastname") }}</span>
			</div>
		</div>

		<div class="vx-row">
			<div id="div-email-content" :class="'vs-con-loading__container'" class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					v-model="resource.email"
					type="email"
					name="email"
					v-validate="'validatorEmail'"
					:label="$t('Email')"
				/>
				<span class="text-danger text-sm" v-show="!validatorErrors.email && !showEmailMessageOk">{{
					emailMessage
				}}</span>
				<span class="text-success text-sm" v-show="emailMessageRes === 'Ok' && showEmailMessageOk">{{
					this.$t("CompanyModule.ValidEmail")
				}}</span>
				<span class="text-danger text-sm" v-show="emailMessageRes === 'Existe' && showEmailMessageOk">{{
					this.$t("CompanyModule.EmailAlreadyExist")
				}}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('ResourceModule.Table.Identification')"
					v-model="resource.identification"
					v-validate="'required'"
					name="identification"
				/>
				<span class="text-danger text-sm" v-show="errors.has('identification')">{{
					errors.first("identification")
				}}</span>
			</div>
		</div>
	</vx-card>
</template>

<script>
import {Validator} from "vee-validate";

export default {
	data() {
		return {
			resource: {
				additional_info: {},
				email: "",
				identification: "",
				lastname: "",
				name: "",
				role_id: 1,
				username: "",
			},
			validatorErrors: {
				email: true,
			},
			emailMessage: this.$t("Login.ValidMessages.Email"),
			emailMessageRes: "",
			showEmailMessageOk: false,
			exist: false,
			activeAlert: true,
		};
	},
	methods: {
		getDataFormResource() {
			this.$emit("getFormDataResourceEmit", this.resource);
		},
		validatorEmail(value) {
			const regex =
				/^[a-z0-9-+*=&'/?^_}{~|`]+(\.[a-z0-9-+*=&'/?^_}{~|`]*)?@[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{1,20}$/;
			const regexTested = regex.test(value);
			this.validatorErrors.email = regexTested;
			this.emailMessage = this.$t("Login.ValidMessages.Email");
			this.showEmailMessageOk = false;
			return regexTested;
		},
		openLoadingInEmail() {
			this.$vs.loading({
				container: "#div-email-content",
				scale: 0.6,
			});
		},
		closeLoadingInEmail() {
			this.$vs.loading.close("#div-email-content > .con-vs-loading");
		},
	},
	created() {
		// Create Custom Validators
		Validator.extend("validatorEmail", this.validatorEmail);
	},
};
</script>
